"use client";

import {useEffect, useRef} from "react";

export const ScrollToPosition = {
    TOP: "top",
    BOTTOM: "bottom",
    HASHTAG: "hashtag",
} as const;

type ScrollToPosition = typeof ScrollToPosition[keyof typeof ScrollToPosition];

export default function ScrollTo({ position } : {
    position?: ScrollToPosition
}) {

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {

        if(ScrollToPosition.TOP === position) {

            window.scrollTo({ top: 0, behavior: "smooth" });

        } else if(ScrollToPosition.BOTTOM === position) {

            window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

        } else if(ScrollToPosition.HASHTAG === position) {

            const locationHashtag = window.location.hash;

            if(locationHashtag) {
                const id = locationHashtag.substring(1);
                const observer = new MutationObserver(() => {
                    const element = document.getElementById(id);
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                        observer.disconnect();
                    }
                });
                observer.observe(document, { childList: true, subtree: true });
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                    observer.disconnect();
                }
            }

        } else {

            if (ref.current) {
                ref.current.scrollIntoView({ behavior: "smooth" });
            }

        }

    }, []);

    return <div ref={ref} />;

}